import React, { useState, useRef, useCallback } from "react";
import { useDispatch } from "react-redux";
import { setPrintaction } from "../../../../../redux/printstate/printActions";
import baseUrl from "../../../../../api/baseUrl";

/** Title-case for display: first letter of each word upper, rest lower (so capitalize works even when title is all caps) */
function toTitleCase(str: any): string {
  if (str == null || typeof str !== "string") return String(str ?? "");
  return str
    .toLowerCase()
    .replace(/\b\w/g, (c) => c.toUpperCase());
}

function PrintText({ item, title }: any) {
  const dispatch = useDispatch();
  const [cursor, setcursor] = useState("grab");
  const dragStart = useRef<{ clientX: number; clientY: number; left: number; top: number } | null>(null);

  const handleMouseMove = useCallback(
    (e: MouseEvent) => {
      if (dragStart.current == null || item?.title == null) return;
      const { clientX, clientY, left, top } = dragStart.current;
      const newLeft = left + (e.clientX - clientX);
      const newTop = top + (e.clientY - clientY);
      dispatch(setPrintaction({ name: item.title, target: "left", value: newLeft }));
      dispatch(setPrintaction({ name: item.title, target: "top", value: newTop }));
      baseUrl.patch("/clinic/addBillDataGrabPosition", {
        name: item.title,
        left: newLeft,
        top: newTop,
      });
    },
    [dispatch, item?.title]
  );

  const handleMouseUp = useCallback(() => {
    dragStart.current = null;
    setcursor("grab");
    document.removeEventListener("mousemove", handleMouseMove);
    document.removeEventListener("mouseup", handleMouseUp);
  }, [handleMouseMove]);

  const handleMouseDown = (e: React.MouseEvent) => {
    e.preventDefault();
    if (item?.title == null) return;
    setcursor("grabbing");
    dragStart.current = {
      clientX: e.clientX,
      clientY: e.clientY,
      left: Number(item?.left) || 0,
      top: Number(item?.top) || 0,
    };
    document.addEventListener("mousemove", handleMouseMove);
    document.addEventListener("mouseup", handleMouseUp);
  };
  return (
    <span
      style={{
        fontWeight: 600,
        position: "absolute",
        top: item?.top,
        left: item?.left,
        fontSize: item?.size,
        display: item?.show ? "block" : "none",
        whiteSpace: "nowrap",
      }}
      className={cursor}
      onMouseDown={handleMouseDown}
    >
      {toTitleCase(title)}
    </span>
  );
}

export default PrintText;
